import { useSortable } from "@dnd-kit/sortable";
import { clsx } from "clsx";
import { type FC, useRef } from "react";

import { Label, SymbolIcon, Tooltip, useTooltip } from "widgets";

import { type ISelectable } from "./GenericOptionsSelectionAndOrdering.js";
import Checkbox from "./forms/Checkbox.js";

interface DraggableProjectListItemProps {
  option: ISelectable;
  index: number;
  disabledSortingTooltip: string;
  onCheckboxClick: any;
  renderItem: any;
  disableSelection: boolean;
}

const DraggableProjectListItem: FC<DraggableProjectListItemProps> = (props) => {
  const { attributes, listeners, setNodeRef, transform, transition, isSorting } = useSortable({
    id: String(props.option.id),
  });
  const dragStyle = transform ? { transform: `translate3d( 0,${transform.y}px, 0)`, transition } : undefined;

  const ref = useRef<HTMLDivElement>(null);
  const tooltipRef = useRef<HTMLDivElement>(null);

  const { state, tooltipProps, triggerProps, arrowProps } = useTooltip(ref, tooltipRef, {
    isDisabled: isSorting,
    noPointerClickEvents: true,
  });

  return (
    <>
      <div {...triggerProps} ref={ref}>
        <div
          className={`generic-sort-selection-item`}
          key={`sort-item-${props.index}`}
          ref={setNodeRef}
          {...attributes}
          {...listeners}
          style={dragStyle}
        >
          <SymbolIcon
            icon={"drag_indicator"}
            className={clsx("drag-handler", { disabled: !!props.disabledSortingTooltip })}
          />
          {props.disableSelection ? (
            <Label>{props.renderItem(props.option)}</Label>
          ) : (
            <div className="checkbox">
              <Checkbox
                id={"option_" + props.option.id}
                label={props.renderItem(props.option)}
                disabled={false}
                checked={props.option.selected}
                onChange={(event) => props.onCheckboxClick(event, props.option)}
              />
            </div>
          )}
        </div>
      </div>
      {state.isOpen && (
        <Tooltip domProps={tooltipProps} arrowProps={arrowProps} ref={tooltipRef}>
          {props.disabledSortingTooltip || "Drag to re-order"}
        </Tooltip>
      )}
    </>
  );
};

export { DraggableProjectListItem };
